export default __webpack_public_path__ + "static/media/NebulaBlue.ce8e2faa.mp4";